<template lang="pug">
  div.waste-generators.bank-books
    e-toolbar(
    :items="items"
    :hideRemoveButton="true"
    :showTotal="true"
    :showViewPanel="false"
    :hideImportBtn="true"
    :hideAddButton="true"
    )
    e-table(
    :items="items"
    @editItem="editItem"
    :showCheckbox="false"
    :showDeleteButton="false"
    :actionColumnWidth="75"
    )

    router-view
</template>

<script>
  import url from '../../utils/url'
  import {wasteGenerators} from '../../api/api-endpoints.js'
  import tableMixin from "../../components/table/table-mixin.js"
  import {BILL_TYPE_INDIVIDUAL, BILL_TYPE_LEGAL, BILL_TYPE_MKD} from "../../config/config"

  const BILL_TYPE_EDIT_ROUTE_MAP = {
    [BILL_TYPE_MKD]: {
      name: 'wasteGenerators.apartmentBuildings.update.billUpdate',
      params: {},
      query: {}
    },
    [BILL_TYPE_INDIVIDUAL]: {
      name: 'wasteGenerators.individualAreas.update.billUpdate',
      params: {},
      query: {}
    },
    [BILL_TYPE_LEGAL]: {
      name: 'wasteGenerators.legalEntities.update.billUpdate',
      params: {},
      query: {}
    }
  }

  export default {
    mixins: [tableMixin],
    methods: {
      editItem (item) {
        let route = null
        try {
          route = BILL_TYPE_EDIT_ROUTE_MAP[item.type.id]
          route.params.id = item.legal_id || item.home_id
          route.params.objectId = item.id
          if (!route.params.id) {
            throw new Error('Нужен legal_id либо home_id для редиректа')
          }
          if (!route.params.objectId) {
            throw new Error('Нужен id для редиректа')
          }
          route.query.prevRoute = url.getRoute(this.$route, true)
        } catch (e) {
          console.error(e)
          this.$e.errorBox(e)
          return
        }
        if (route) {
          this.$router.push(route)
        }
      },
      getEndpoint (route) {
        return wasteGenerators.bankBooks(route)
      },
      getDeleteUrl () {
        return null
      }

    }
  }
</script>
